import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  successMsg: null,
};

const previewFileData = createSlice({
  name: 'previewFileData',
  initialState,
  reducers: {
    fetchDownloadSuccess: (state, action) => {
      state.successMsg = action.payload.response;
      state.isLoading = false;
    },
    resetDownloadData: (state, action) => {
      state.isLoading = false;
      state.successMsg = null;
    },
    fetchDownloadSuccessMsg: (state, action) => {
      state.successMsg = action.payload.message;
      state.isLoading = false;
    },
  },
});

export default previewFileData.reducer;

export const {fetchDownloadSuccess, resetDownloadData, fetchDownloadSuccessMsg} =
  previewFileData.actions;

export const resetDownloadMsg = () => {
  return (dispatch) => {
    dispatch(resetDownloadData());
  };
};
